import React, { useEffect } from "react";
import {
    createStyles,
    createTheme,
    makeStyles,
    MenuItem,
    Select,
    ThemeProvider,
} from "@material-ui/core";
import { CaptionLanguage } from "../../../common/video/models/VideoCaption";
import { t } from "i18next";

const useStyles = makeStyles(() =>
    createStyles({
        formSelect: {
            border: "1px solid var(--gray-38)",
            width: "192px",
            color: "var(--gray-80)",
            height: "40px",
            fontSize: "14px",
            background: "#FFFFFF0D",
            borderRadius: "5px",
            fontFamily: "noto-sans-cjk-jp,sans-serif !important",
            "& .MuiSelect-icon": {
                color: "white",
            },
            "& .MuiSelect-selectMenu": {
                color: "white",
            },
        },
        menuItem: {
            height: "32px",
            backgroundColor: "var(--textfield-bg)",
            color: "var(--gray-80)",
            fontSize: "14px",
            fontFamily: "noto-sans-cjk-jp,sans-serif !important",
            "&:hover": {
                color: "var(--gray-80)",
                backgroundColor: "#FFFFFF0D",
            },
        },
        dropdownStyle: {
            color: "white",
            backgroundColor: "var(--textfield-bg)",
            marginTop: "55px",
        },
        checkBox: {
            color: "var(--gray-80)",
            marginLeft: "-14px",
        },
    })
);

const theme = createTheme({
    palette: {
        primary: {
            main: "#16ADC1",
        },
        secondary: {
            main: "#4395EA",
        },
    },
});

interface SelectLanguageProps {
    captions?: CaptionLanguage[];
    selectLanguage: string;
    setInputLanguage: (target: string) => void;
    isSearch: boolean;
    searchLanguage?: string[];
}

export default function SelectLanguage({
    captions,
    selectLanguage,
    setInputLanguage,
    isSearch,
    searchLanguage,
}: SelectLanguageProps) {
    const classes = useStyles();

    // 表示言語変更
    const handleChangeLanguage = (language: string) => {
        setInputLanguage(language);
    };

    //検索時、該当の言語を翻訳言語のSELECTボックスで選択させる。
    useEffect(() => {
        if (isSearch && searchLanguage?.includes("ja")) {
            handleChangeLanguage("ja");
        } else if (isSearch && searchLanguage?.includes("en")) {
            handleChangeLanguage("en");
        } else if (isSearch && searchLanguage?.includes("zh-Hans")) {
            handleChangeLanguage("zh-Hans");
        } else if (isSearch && searchLanguage?.includes("vi")) {
            handleChangeLanguage("vi");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchLanguage]);

    return (
        <ThemeProvider theme={theme}>
            <Select
                required
                color="secondary"
                onChange={(event) => handleChangeLanguage(event.target.value as string)}
                value={selectLanguage}
                id="language-select"
                variant="outlined"
                defaultValue=""
                MenuProps={{
                    getContentAnchorEl: null,
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "left",
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                    },
                    classes: {
                        paper: classes.dropdownStyle,
                    },
                }}
                className={classes.formSelect}
            >
                {captions && captions.some((caption) => caption.language === "ja") && (
                    <MenuItem value={"ja"} className={classes.menuItem}>
                        {t("日本語")}
                    </MenuItem>
                )}
                {isSearch && searchLanguage?.includes("ja") && (
                    <MenuItem value={"ja"} className={classes.menuItem}>
                        {t("日本語")}
                    </MenuItem>
                )}
                {captions && captions.some((caption) => caption.language === "en") && (
                    <MenuItem value={"en"} className={classes.menuItem}>
                        English
                    </MenuItem>
                )}
                {isSearch && searchLanguage?.includes("en") && (
                    <MenuItem value={"en"} className={classes.menuItem}>
                        English
                    </MenuItem>
                )}
                {captions && captions.some((caption) => caption.language === "zh-Hans") && (
                    <MenuItem value={"zh-Hans"} className={classes.menuItem}>
                        {t("中文")}
                    </MenuItem>
                )}
                {isSearch && searchLanguage?.includes("zh-Hans") && (
                    <MenuItem value={"zh-Hans"} className={classes.menuItem}>
                        {t("中文")}
                    </MenuItem>
                )}
                {captions && captions.some((caption) => caption.language === "vi") && (
                    <MenuItem value={"vi"} className={classes.menuItem}>
                        {t("tiếng Việt")}
                    </MenuItem>
                )}
                {isSearch && searchLanguage?.includes("vi") && (
                    <MenuItem value={"vi"} className={classes.menuItem}>
                        {t("tiếng Việt")}
                    </MenuItem>
                )}
            </Select>
        </ThemeProvider>
    );
}
